var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.673 18.194v1.23H8v-.942l2.1-2.184c.87-.942 1.118-1.333 1.118-1.876 0-.676-.482-1.095-1.291-1.095a2.54 2.54 0 00-1.528.51l-.164-.102V12.58a3.444 3.444 0 011.855-.482c1.598 0 2.542.819 2.542 2.141 0 .922-.35 1.537-1.671 2.911l-.88.902v.143zm5.869-.133h-.718v1.363h-1.352V18.06h-2.89v-.944l2.07-4.867h1.333v.204l-1.845 4.264v.113h1.332v-1.753h1.353v1.753h.717zM24 15.683v3.74h-1.373v-3.452c0-.544-.247-.822-.738-.822a.913.913 0 00-.963.861l-.001.042v3.372h-1.373V12.25h1.373v2.337h.082a1.702 1.702 0 011.322-.625A1.532 1.532 0 0124 15.682zm3.014-8.473L24.05 2.172l-1.019 1.752-.262-.146A13.972 13.972 0 002.722 20.424h1.975a12.123 12.123 0 0117.17-15.031l.27.15-.955 1.667zm-2.912 17.845a12.134 12.134 0 01-13.95 1.577l-.271-.148.956-1.693H5l2.963 5.06.99-1.75.264.147a13.992 13.992 0 0020.065-16.68h-1.963a12.134 12.134 0 01-3.217 13.487z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--arrow-24-hours-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'Arrow24HoursIcon';
export default Icon;